<div class="pme-container display-utils-col">
  <pme-window-shop-manager-header
    *ngIf="this.headerContent"
    [headerContent]="this.headerContent"
  >
  </pme-window-shop-manager-header>
  
  <div
    class="selector display-utils-row display-utils-center-center display-utils-gap-8"
  >
    <pme-product-selector
      *ngIf="periodicityList?.length > 1"
      [titlesToggles]="periodicityList"
      (selectionChanged)="onSelectionChanged($event)"
    ></pme-product-selector>
  </div>

  <div class="pme-carousel-swiper-container display-utils-lt-md-flex-100">
    <ng-container *ngIf="currentPlans?.length > 0">
      <pme-carousel-swiper
        [identifier]="'descomplica-products'"
        [items]="currentPlans"
      >
        <ng-template let-product let-i="index">
          <pme-product-descomplica
            [productData]="product"
            (clickOnProduct)="navigate(i)"
            [elementIndex]="i"
          ></pme-product-descomplica>
        </ng-template>
      </pme-carousel-swiper>
    </ng-container>
  </div>

  <pme-comparative-sdsn
    *ngIf="currentPlans?.length > 0"
    class="comparative"
    [shopWindowItems]="currentPlans"
    (clickOnProduct)="navigate($event)"
  ></pme-comparative-sdsn>

  <mat-divider class="divider"></mat-divider>

  <pme-payment-methods></pme-payment-methods>
  <mat-divider class="divider"></mat-divider>
</div>
